import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
import { Stars } from './Stars';
import { SHORT_TESTIMONIALS } from '../data/content';
export function ShortTestimonials() {
  return <section className="px-5 py-10" data-id="element-222" data-mp="3d5d6i15n7u09">
      <div className="mx-auto max-w-md" data-id="element-223" data-mp="3d27h0kt3qq40">
        <h2 className="text-center font-anton text-2xl leading-tight text-white" data-id="element-224" data-mp="384pi7n8str9q">
          Entrenadores como tú ya lo están aplicando
        </h2>

        <div className="mt-6 grid grid-cols-1 gap-3" data-id="element-225" data-mp="3n0nct132qnju">
          {SHORT_TESTIMONIALS.map((t, i) => <motion.figure key={i} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.4
        }} transition={{
          duration: 0.4,
          delay: i * 0.05
        }} className="rounded-xl border border-white/10 bg-[#111]/90 p-4" data-id="element-226" data-mp="3i1aosd0gvafo" data-mpi={i}>
              <div className="flex items-center justify-between" data-id="element-227" data-mp="2yu64g8vyc01l">
                <Stars data-id="element-228" data-mp="2ywsecf6bermz" />
                <QuoteIcon className="h-5 w-5 text-[#F5C518]/50" data-id="element-229" data-mp="33u0ts802whkj" />
              </div>
              <blockquote className="mt-2.5 text-[14px] leading-snug text-neutral-200" data-id="element-230" data-mp="37ve1yoqn8wum">
                "{t.text}"
              </blockquote>
              <figcaption className="mt-2.5 text-[13px] font-600 text-white" data-id="element-231" data-mp="3ctfm7czt327o">
                {t.name}, {t.age}{' '}
                <span className="font-400 text-neutral-400" data-id="element-232" data-mp="3hrz6za2ny7yg">· {t.city}</span>
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}